export const WeekScheduleSvg = (color?: string) => (
	<svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M27.8465 13.0996L26.6215 18.1917C25.5715 22.5894 23.4965 24.3679 19.5965 24.0025C18.9715 23.9537 18.2965 23.8441 17.5715 23.6736L15.4715 23.1863C10.259 21.9803 8.6465 19.4708 9.8715 14.3787L11.0965 9.27451C11.3465 8.23904 11.6465 7.33758 12.0215 6.59448C13.484 3.64646 15.9715 2.85463 20.1465 3.817L22.234 4.2921C27.4715 5.48593 29.0715 8.00759 27.8465 13.0996Z"
			stroke={color || '#98B2B9'}
			strokeWidth="1.82729"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			opacity="0.4"
			d="M19.5964 24.0025C18.8214 24.5141 17.8464 24.9405 16.6589 25.3181L14.6839 25.9516C9.72136 27.5109 7.10886 26.2074 5.49636 21.3712L3.89636 16.5593C2.29636 11.7231 3.62136 9.16487 8.58386 7.60558L10.5589 6.97212C11.0714 6.81376 11.5589 6.67976 12.0214 6.59448C11.6464 7.33758 11.3464 8.23904 11.0964 9.27451L9.87136 14.3787C8.64636 19.4708 10.2589 21.9803 15.4714 23.1863L17.5714 23.6736C18.2964 23.8441 18.9714 23.9537 19.5964 24.0025Z"
			stroke={color || '#98B2B9'}
			strokeWidth="1.82729"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			opacity="0.4"
			d="M16.5713 10.7729L22.6338 12.2713"
			stroke={color || '#98B2B9'}
			strokeWidth="1.82729"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			opacity="0.4"
			d="M15.3463 15.4873L18.9713 16.3888"
			stroke={color || '#98B2B9'}
			strokeWidth="1.82729"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
